import http from './http'

const CompanyAccount = `CompanyAccount`

function getPages(params) {
  return http.post(`${CompanyAccount}/getPages`, params)
}
function companyUpdate(params) {
  return http.post(`${CompanyAccount}/update`, params)
}
function getLogPages(params) {
  return http.post(`${CompanyAccount}/getLogPages`, params)
}
function getChangeRecordPages(params) {
  return http.post(`${CompanyAccount}/getChangeRecordPages`, params)
}
function disable(params) {
  return http.put(`${CompanyAccount}/disable`, params)
}
function enable(params) {
  return http.put(`${CompanyAccount}/enable`, params)
}
const payment = `/payment`

function getPaymentPagesList(params) {
    return http.post(`${payment}/getPaymentPagesList`, params)
}
function getPaymentLogs(params) {
  return http.get(`${payment}/getPaymentLogs`, params)
}
function approval(params) {
  return http.post(`${payment}/approval`, params)
}
function addPayment(params) {
  return http.post(`${payment}/addPayment`, params)
}
function getPaymentVerifyDetails(params) {
  return http.get(`${payment}/getPaymentVerifyDetails`, params)
}
const quote = `/Quote`

function quotesResult(params) {
    return http.get(`${quote}/quotesResult`, params)
}
export {
    getPages,
    companyUpdate,
    getLogPages,
    getChangeRecordPages,
    disable,
    enable,
    getPaymentPagesList,
    getPaymentLogs,
    approval,
    quotesResult,
    addPayment,
    getPaymentVerifyDetails
}
